import { GenericSuggestion } from 'types/suggestions/CoreSuggestions';

// Sort suggestions so Quick Quote appears before Load Building.
export function suggestionSortComparator(
  a: GenericSuggestion,
  b: GenericSuggestion
): number {
  if (
    a.pipeline === 'quick_quote_pipeline' &&
    b.pipeline === 'load_building_pipeline'
  )
    return -1;
  if (
    a.pipeline === 'load_building_pipeline' &&
    b.pipeline === 'quick_quote_pipeline'
  )
    return 1;
  return 0;
}
